import { useCallback } from "react"
import { useAxiosInstances } from "../../axios-instance"
import { ILevantamentoQuantitativo } from "../../../application/models"

export const useLevantamentoQuantitativoApi = () => {
    const { axiosAuthInstance } = useAxiosInstances()

    const deleteLevantamentoApi = useCallback(async (data: {
        IdVelesGeoLevantamentoQuantitativo: number
    }): Promise<ILevantamentoQuantitativo> => {
        try {
            const result = await axiosAuthInstance.delete(`/geo-veles/levantamento-quantitativo/${data.IdVelesGeoLevantamentoQuantitativo}`)

            return result.data.levantantamentoQuantitativo
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    const findLevantamentoByIdApi = useCallback(async (data: {
        IdVelesGeoLevantamentoQuantitativo: number
    }): Promise<ILevantamentoQuantitativo> => {
        try {
            const response = await axiosAuthInstance.get(`/geo-veles/levantamento-quantitativo/${data.IdVelesGeoLevantamentoQuantitativo}`)

            return response.data.levantamentoQuantitativo
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    const findLevantamentosByIdProjetoApi = useCallback(async (data: {
        IdVelesGeoProjeto: number
    }): Promise<ILevantamentoQuantitativo[]> => {
        try {
            const result = await axiosAuthInstance.get(`/geo-veles/levantamento-quantitativo/projeto/${data.IdVelesGeoProjeto}`)

            return result.data.levantamentosQuantitativos
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    const createLevantamentoApi = useCallback(async (data: {
        IdVelesGeoProjeto: number
        Nome: string
        Colunas: string[]
    }): Promise<ILevantamentoQuantitativo> => {
        try {
            const result = await axiosAuthInstance.post('/geo-veles/levantamento-quantitativo', {
                Colunas: data.Colunas,
                IdVelesGeoProjeto: data.IdVelesGeoProjeto,
                Nome: data.Nome
            })

            return result.data.levantamentoQuantitativo
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    const updateLevantamentoApi = useCallback(async (data: {
        IdVelesGeoLevantamentoQuantitativo: number
        Nome: string
        Colunas: string[]
    }): Promise<ILevantamentoQuantitativo> => {
        try {
            const result = await axiosAuthInstance.put('/geo-veles/levantamento-quantitativo', {
                Colunas: data.Colunas,
                IdVelesGeoLevantamentoQuantitativo: data.IdVelesGeoLevantamentoQuantitativo,
                Nome: data.Nome
            })

            return result.data.levantamentoQuantitativo
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    const processarLevantamentoApi = useCallback(async (data: {
        IdUsuario: number
        IdVelesGeoLevantamentoQuantitativo: number
    }): Promise<number> => {
        try {
            const result = await axiosAuthInstance.post('/geo-veles/levantamento-quantitativo/processar', {
                IdUsuario: data.IdUsuario,
                IdVelesGeoLevantamentoQuantitativo: data.IdVelesGeoLevantamentoQuantitativo
            })

            return result.data.IdVelesGeoProcesso
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    return {
        deleteLevantamentoApi,
        findLevantamentoByIdApi,
        findLevantamentosByIdProjetoApi,
        createLevantamentoApi,
        updateLevantamentoApi,
        processarLevantamentoApi
    }
}